import React, { useState } from "react";

import { useNavigate } from "react-router-dom";
import { MenuBuilder } from "../../components/menu/MenuBuilder";

const FinancePage = ({}) => {
  const navigate = useNavigate();
  let user = JSON.parse(localStorage.getItem("user"));

  let menu = [
    {
      auth: "Monitoring_Quotation",
      name: "Monitoring Quotation",
      path: "/operasional-monitoring-finance",
    },
    {
      auth: "Quotation",
      name: "Quotation",
      path: "/quotation-or-contract-list",
    },
    {
      auth: "Additional_Quotation",
      name: "Additional Quotation",
      path: "/monitoring-additional-quotation-or-contract",
    },
    {
      // Dipindah dari halaman Operasional (2026-08-03) dan diberi nama
      // "Invoice Quotation". Otoritasnya sengaja tetap TOperationalMonitoring —
      // sama seperti saat masih di Operasional — supaya tak ada user yang
      // mendadak kehilangan atau mendapat akses hanya karena menunya berpindah.
      auth: "TOperationalMonitoring",
      name: "Invoice Quotation",
      path: "/invoice-list-v2",
    },
    {
      auth: "Permohonan_Pembayaran_PO",
      name: "Pengajuan Pembayaran AP",
      path: "/finance/pembayaran-ap",
    },
    {
      auth: "Permohonan_Pembayaran_Non_PO",
      name: "Pengajuan Pembayaran",
      path: "/finance/Kas-Bank",
    },
    {
      auth: "Pengeluaran_Kas_HO",
      name: "Pengeluaran Kas HO",
      path: "/finance/pettycash/U0001",
    },
    {
      auth: "Pengeluaran_Kas_SO",
      name: "Pengeluaran Kas SO",
      path: "/finance/pettycash/U0002",
    },
    {
      auth: "Penerimaan_Dana",
      name: "Penerimaan Kas/Bank",
      path: "/finance/penerimaan-dana",
    },
  ];
  let Report = [
    {
      auth: "Invoice_Job_Request",
      name: "Invoice Job Request",
      path: "/finance/report/invoice",
    },
    {
      auth: "Buku_Kas_HO",
      name: "Buku Kas HO ",
      path: "/finance/report/buku-kas/U0001",
    },
    {
      auth: "Buku_Kas_SO",
      name: "Buku Kas SO ",
      path: "/finance/report/buku-kas/U0002",
    },
    {
      auth: "Buku_Bank_HO",
      name: "Buku Bank",
      path: "/finance/report/buku-bank/U0001",
    },
    {
      auth: "Monitoring_Pembayaran_PO",
      name: "Monitoring Pembayaran AP",
      path: "/finance/report/pembayaran-ap",
    },
    {
      auth: "Monitoring_Pembayaran_Non_PO",
      name: "Monitoring Pengajuan Pembayaran",
      path: "/finance/report/pembayaran-non-po",
    },
    {
      auth: "Buku_Kas_HO",
      name: "Monitoring Pengeluaran Kas HO",
      path: "/finance/report/Petty-Cash-HO",
    },
    {
      auth: "Buku_Kas_SO",
      name: "Monitoring Pengeluaran Kas SO",
      path: "/finance/report/Petty-CashSO",
    },
    {
      auth: "Monitoring_Penerimaan_Dana",
      name: "Monitoring Penerimaan Kas dan Bank",
      path: "/finance/report/penerimaan-dana",
    },
    {
      // Kedua halaman ini sudah lama ada di App.js tapi tak pernah punya entri
      // menu, jadi hanya bisa dibuka dengan mengetik URL. Otoritasnya memakai
      // kunci yang SUDAH ada (Penerimaan_Kas_HO/SO — sama dengan yang menggerbangi
      // approval dokumen penerimaan kas, dan sudah tampil di Setup > Otoritas),
      // supaya tak perlu kolom SOtoritas baru dan tak ada user yang mendadak
      // kehilangan atau mendapat akses.
      auth: "Penerimaan_Kas_HO",
      name: "Monitoring Penerimaan Kas/Bank HO",
      path: "/finance/report/penerimaan-HO",
    },
    {
      auth: "Penerimaan_Kas_SO",
      name: "Monitoring Penerimaan Kas/Bank SO",
      path: "/finance/report/penerimaan-SO",
    },

  ];
  const [listMenu, setListMenu] = useState(menu);
  const [listReport, setListReport] = useState(Report);

  const filterMenu = (event) => {
    const filtered = menu.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListMenu(filtered);
  };
  const filterReport = (event) => {
    const filtered = Report.filter(({ name }) =>
      name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setListReport(filtered);
  };
  return (
    <div className="md:ml-64">
      <div className="w-full flex flex-col items-center">
        <div className="w-full px-4 my-4 ">
          <MenuBuilder
            name="Transaction"
            menuController={filterMenu}
            listMenu={listMenu}
          />
          <hr className={"border border-main-100 my-6"} />
          <MenuBuilder
            name="Report"
            menuController={filterReport}
            listMenu={listReport}
          />
        </div>
      </div>
    </div>
  );
};

export default FinancePage;
